import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  ModalContainer,
  Header,
  Tabs,
} from '@core/dashboard/components/PopoverModal';

import Emojis from './Emojis';
import Reactions from './Reactions';

import { ActionsTabs } from '../interfaces';
import { IActionsContent } from './interfaces';

const ActionsContent = ({
  activeTab,
  onChangeTab,
  onClose,
}: IActionsContent) => {
  const { t: translate } = useTranslation();

  return (
    <ModalContainer
      header={
        <>
          <Header text={translate('actions.actions')} onClose={onClose} />
          <Tabs
            active={activeTab}
            onChange={onChangeTab}
            tabs={[
              { label: translate('actions.emojis'), value: ActionsTabs.Emojis },
              {
                label: translate('actions.reactions'),
                value: ActionsTabs.Reactions,
              },
            ]}
          />
        </>
      }
      hasTabs
    >
      {activeTab === ActionsTabs.Emojis && <Emojis />}
      {activeTab === ActionsTabs.Reactions && <Reactions onClose={onClose} />}
    </ModalContainer>
  );
};

export default ActionsContent;
